export default "__VITE_ASSET__46$wGqPD__"